var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-distribution-bar"},[_c('span',{staticClass:"app-distribution-bar__candle",style:(_vm.candleStyle)},[_c('span',{style:(_vm.innerSpanStyle)})])])
}
var staticRenderFns = []

export { render, staticRenderFns }